import type { IconData } from '@stacksjs/iconify-core'

export const stroller: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M45 17q0-1.812-.03-3.361c-.113-5.98-4.628-10.496-10.609-10.608A178 178 0 0 0 31 3s-1 6.5-1 14m15 0c0 2.907-.485 5.674-1.051 7.917c-.865 3.423-3.757 5.677-7.282 5.876C34.57 30.912 31.748 31 28 31s-6.57-.088-8.667-.207c-3.525-.2-6.417-2.453-7.282-5.876C11.485 22.674 11 19.907 11 17zm-3 24.5a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0m-28 0a4.5 4.5 0 1 0 9 0a4.5 4.5 0 0 0-9 0M11 17A452 452 0 0 0 8.329 5.339c-.207-.851-.785-1.562-1.632-1.788C5.702 3.285 4.137 3 2 3\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default stroller
